// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connectivity-container {
    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;
    padding: 0 0 5rem;
    max-width: 1800px;
    margin: 0;
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */



.header-actions {
    display: flex;
    gap: 15px;
}

.help-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: var(--surface-light);
    border: var(--glass-border);
    border-radius: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.2s;
}

.status-badge-active {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(16, 185, 129, 0.08);
    border: 1px solid rgba(16, 185, 129, 0.2);
    color: #10b981;
    border-radius: 20px;
    font-weight: 600;
    font-size: 0.8rem;
}

/* ── LAYOUT GRID (RESTORED) ── */
.connectivity-grid {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
}

.main-config-layout {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 2.5rem;
    align-items: start;
}

.config-card {
    background: transparent;
    backdrop-filter: none;
    border: none;
    box-shadow: none;
    overflow: visible;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.config-card:hover {
    border-color: transparent;
}

.card-header {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border-radius: 24px;
    border: var(--glass-border) !important;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    padding: 1.5rem 2.5rem;
    display: flex;
    align-items: center;
    gap: 15px;
}

.card-header h3 {
    font-size: 1.05rem;
    font-weight: 600;
    color: var(--text-secondary);
    margin: 0;
}

.icon-wrap.vpn {
    width: 38px;
    height: 38px;
    background: var(--gradient-main);
    color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.multi-cloud-selector {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border-radius: 24px;
    border: var(--glass-border) !important;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.75rem 2.5rem;
    gap: 2rem;
}

.selector-group {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.selector-group label {
    font-size: 0.72rem;
    font-weight: 500;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.cloud-chips {
    display: flex;
    gap: 10px;
}

.cloud-chip {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0.7rem;
    background: var(--bg-card);
    border: 1.5px solid var(--border-color);
    border-radius: 14px;
    font-size: 0.82rem;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.2s;
}

.cloud-chip.active {
    background: var(--surface);
    color: var(--text-main);
    border-width: 2px;
}

.cloud-chip.active:has(img[alt="AWS"]) {
    border-color: #FF9900;
}

.cloud-chip.active:has(img[alt="GCP"]) {
    border-color: #4285F4;
}

.cloud-chip.active:has(img[alt="Azure"]) {
    border-color: #0089D6;
}

.swap-btn {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: var(--surface-light);
    border: var(--glass-border);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
    margin-top: 1.5rem;
    cursor: pointer;
}

/* Provider Slates */
.provider-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    padding: 0;
}

.provider-section {
    padding: 2.5rem;
    border-radius: 24px;
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border) !important;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.provider-section.source,
.provider-section.target {
    border-top: none !important;
}

.provider-section.aws {
    border: 1px solid rgba(255, 153, 0, 0.3) !important;
}

html[data-theme='dark'] .provider-section.aws {
    box-shadow: 0 0 35px rgba(255, 153, 0, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

.provider-section.aws:hover {
    border-color: rgba(255, 153, 0, 0.6) !important;
    box-shadow: 0 0 45px rgba(255, 153, 0, 0.18), var(--glass-shadow);
}

.provider-section.gcp {
    border: 1px solid rgba(66, 133, 244, 0.3) !important;
}

html[data-theme='dark'] .provider-section.gcp {
    box-shadow: 0 0 35px rgba(66, 133, 244, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

.provider-section.gcp:hover {
    border-color: rgba(66, 133, 244, 0.6) !important;
    box-shadow: 0 0 45px rgba(66, 133, 244, 0.18), var(--glass-shadow);
}

.provider-section.azure {
    border: 1px solid rgba(0, 137, 214, 0.3) !important;
}

html[data-theme='dark'] .provider-section.azure {
    box-shadow: 0 0 35px rgba(0, 137, 214, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

.provider-section.azure:hover {
    border-color: rgba(0, 137, 214, 0.6) !important;
    box-shadow: 0 0 45px rgba(0, 137, 214, 0.18), var(--glass-shadow);
}

.provider-label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.72rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.provider-section.source .provider-label {
    color: #FF9900;
}

.provider-section.target .provider-label {
    color: #4285F4;
}

.discovery-pill.success {
    background: rgba(16, 185, 129, 0.08);
    color: #10b981;
    padding: 4px 12px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 600;
}

/* Forms */
.form-group label {
    font-size: 0.78rem;
    font-weight: 500;
    color: var(--text-secondary);
    margin-bottom: 8px;
}

.form-input,
.form-select {
    font-family: 'Outfit', sans-serif;
    background: var(--bg-input);
    border: 1.5px solid var(--border-color);
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--text-main);
    width: 100%;
    transition: all 0.2s;
}

.form-input:focus,
.form-select:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 4px var(--primary-glow);
}

/* Shared Params */
.shared-config-area {
    padding: 2.5rem;
    border: var(--glass-border) !important;
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border-radius: 24px;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
}

.input-with-button {
    display: flex;
    align-items: stretch;
    gap: 15px;
}

.save-config-btn {
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 12px;
    padding: 0 28px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.save-config-btn:hover {
    background: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.35);
}

.save-config-btn:active {
    transform: translateY(0);
}

.input-hint {
    margin-top: 10px;
    font-size: 0.68rem;
    color: var(--text-muted);
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Terminal */
.terraform-terminal-wrap {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border) !important;
    border-radius: 24px;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    padding: 2.5rem;
    position: relative;
    transition: all 0.3s ease-in-out;
}

html[data-theme="light"] .terraform-terminal-wrap {
    background: var(--card-bg) !important;
}

.terminal-header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 1.5rem;
}

.terminal-expand-btn {
    margin-left: auto;
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 6px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid transparent;
}

.terminal-expand-btn:hover {
    background: var(--surface-light);
    color: var(--text-main);
    border-color: var(--card-border);
}

.terminal-modal-ref {
    background: var(--card-bg) !important;
    backdrop-filter: var(--glass-blur) !important;
    border: var(--glass-border) !important;
    width: 90vw;
    height: 90vh;
    border-radius: 24px;
    padding: 3rem;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow) !important;
    display: flex;
    flex-direction: column;
}

.terminal-modal-header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 1.5rem;
}

.terminal-close-btn {
    margin-left: auto;
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 6px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid transparent;
}

.terminal-close-btn:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    border-color: rgba(239, 68, 68, 0.2);
}

.terminal-modal-ref .terminal-body {
    flex: 1 1;
    height: auto;
}

.terminal-dots {
    display: flex;
    gap: 8px;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.dot.red {
    background: #ff5f56;
    box-shadow: 0 0 6px rgba(255, 95, 86, 0.5);
}

.dot.yellow {
    background: #ffbd2e;
    box-shadow: 0 0 6px rgba(255, 189, 46, 0.5);
}

.dot.green {
    background: #27c93f;
    box-shadow: 0 0 6px rgba(39, 201, 63, 0.5);
}

.terminal-title {
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.terminal-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 1.5rem;
}

.step-btn {
    background: var(--surface-light);
    border: var(--glass-border);
    backdrop-filter: var(--glass-blur);
    padding: 10px 20px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.85rem;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: var(--glass-inner-glow);
}

.step-btn:hover:not(:disabled) {
    background: var(--gradient-hover);
    color: var(--text-main);
    border-color: rgba(99, 102, 241, 0.3);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1), var(--glass-inner-glow);
}

.step-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.apply-btn {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
    display: flex;
    align-items: center;
    gap: 8px;
}

.apply-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    transform: translateY(-1.5px);
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.35);
}

.apply-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

.destroy-btn-ref {
    margin-left: auto;
    background: rgba(239, 68, 68, 0.05);
    border: 1px solid rgba(239, 68, 68, 0.2);
    color: #ef4444;
    padding: 10px 20px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.destroy-btn-ref:hover:not(:disabled) {
    background: rgba(239, 68, 68, 0.1);
    border-color: rgba(239, 68, 68, 0.45);
    color: #f87171;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.1);
}

.destroy-btn-ref:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

.terminal-body {
    background: rgba(10, 12, 22, 0.85) !important;
    backdrop-filter: blur(16px);
    border-radius: 16px;
    padding: 24px;
    height: 320px;
    overflow-y: auto;
    font-family: 'Fira Code', 'JetBrains Mono', 'SF Mono', Consolas, monospace;
    font-size: 0.85rem;
    line-height: 1.7;
    color: #f8fafc;
    box-shadow: inset 0 2px 20px rgba(0, 0, 0, 0.85), inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 4px 20px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(99, 102, 241, 0.25) !important;
    transition: all 0.3s ease;
}

.terminal-body::-webkit-scrollbar {
    width: 8px;
}

.terminal-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
}

.terminal-body::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
}

.terminal-body::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
}

.log-placeholder {
    color: #94a3b8;
    opacity: 0.7;
}

.log-line {
    display: flex;
    gap: 12px;
    margin-bottom: 4px;
    word-break: break-all;
    transition: background 0.2s;
    padding: 2px 4px;
    border-radius: 4px;
}

.log-line:hover {
    background: rgba(255, 255, 255, 0.05);
}

.log-prefix {
    font-weight: 700;
    font-size: 0.75rem;
    padding: 2px 6px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: fit-content;
    margin-top: 2px;
}

.log-prefix.sys {
    background: rgba(99, 102, 241, 0.12);
    color: #818cf8;
    border: 1px solid rgba(99, 102, 241, 0.3);
    text-shadow: 0 0 8px rgba(129, 140, 248, 0.4);
    box-shadow: 0 0 8px rgba(99, 102, 241, 0.05);
}

.log-prefix.err {
    background: rgba(239, 68, 68, 0.12);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.3);
    text-shadow: 0 0 8px rgba(248, 113, 113, 0.4);
    box-shadow: 0 0 8px rgba(239, 68, 68, 0.05);
}

.log-content {
    flex: 1 1;
    white-space: pre-wrap;
    color: #f8fafc;
}

.log-line.add .log-content {
    color: #4ade80;
    text-shadow: 0 0 8px rgba(74, 222, 128, 0.25);
}

.log-line.destroy .log-content {
    color: #f87171;
    text-shadow: 0 0 8px rgba(248, 113, 113, 0.25);
}

.log-line.change .log-content {
    color: #fbbf24;
    text-shadow: 0 0 8px rgba(251, 191, 36, 0.25);
}

.log-line.plan-summary .log-content {
    color: #22d3ee;
    font-weight: 600;
    text-shadow: 0 0 10px rgba(34, 211, 238, 0.3);
}

.log-line.success-exit {
    background: rgba(16, 185, 129, 0.1) !important;
    border-left: 4px solid #10b981;
    box-shadow: inset 0 0 15px rgba(16, 185, 129, 0.1);
}

.log-line.success-exit .log-content {
    color: #34d399;
    font-weight: 700;
    text-shadow: 0 0 10px rgba(52, 211, 153, 0.4);
}

/* Status Panel (Side) */
.status-side-panel {
    position: sticky;
    top: 24px;
    display: flex;
    flex-direction: column;
    gap: 2.25rem;
    height: fit-content;
    z-index: 10;
}

.status-card-ref {
    background: var(--card-bg) !important;
    backdrop-filter: var(--glass-blur);
    border-radius: 24px;
    border: 1.5px solid rgba(16, 185, 129, 0.35) !important;
    padding: 1.75rem;
    box-shadow: 0 0 15px rgba(16, 185, 129, 0.1), var(--glass-shadow);
    transition: border-color 0.4s ease, box-shadow 0.4s ease, transform 0.35s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.status-card-ref:hover {
    transform: translateY(-5px) scale(1.02);
    border-color: rgba(16, 185, 129, 0.6) !important;
    box-shadow: 0 0 25px rgba(16, 185, 129, 0.25), 0 20px 45px rgba(16, 185, 129, 0.15), var(--glass-shadow);
}

.status-card-ref.offline {
    border: 1.5px solid rgba(239, 68, 68, 0.35) !important;
    box-shadow: 0 0 15px rgba(239, 68, 68, 0.1), var(--glass-shadow);
}

html[data-theme='dark'] .status-card-ref {
    box-shadow: 0 0 35px rgba(16, 185, 129, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

html[data-theme='dark'] .status-card-ref.offline {
    box-shadow: 0 0 35px rgba(239, 68, 68, 0.08), var(--glass-shadow), var(--glass-inner-glow);
}

.status-card-ref.offline:hover {
    border-color: rgba(239, 68, 68, 0.6) !important;
    box-shadow: 0 0 25px rgba(239, 68, 68, 0.25), 0 20px 45px rgba(239, 68, 68, 0.15), var(--glass-shadow);
}

.status-header-min {
    display: flex;
    justify-content: space-between;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--text-main);
}

.status-visualization {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;
}

.heartbeat-ring {
    width: 64px;
    height: 64px;
    background: rgba(16, 185, 129, 0.05);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #10b981;
    margin-bottom: 1rem;
    position: relative;
}

.heartbeat-ring::after {
    content: '';
    position: absolute;
    inset: -3px;
    border: 2px solid rgba(16, 185, 129, 0.3);
    border-radius: 50%;
    animation: ripple 2s infinite;
}

@keyframes ripple {
    0% {
        transform: scale(1);
        opacity: 0.5;
    }

    100% {
        transform: scale(1.4);
        opacity: 0;
    }
}

.status-tag-v2 {
    font-weight: 600;
    font-size: 0.92rem;
    color: var(--text-secondary);
}

.status-metas-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid var(--card-border);
}

.meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

.meta-item .lbl {
    font-size: 0.7rem;
    color: var(--text-secondary);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1.2;
}

.meta-item .val {
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--text-main);
}

.meta-item .val.success {
    color: #10b981;
}

/* SSH Ledger */
.ssh-summary-card-ref {
    background: var(--card-bg) !important;
    backdrop-filter: var(--glass-blur);
    border-radius: 24px;
    border: var(--glass-border) !important;
    padding: 1.75rem;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.ssh-summary-card-ref:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 20px 45px rgba(99, 102, 241, 0.15), var(--glass-shadow);
    border-color: rgba(99, 102, 241, 0.4) !important;
}

.count-pill {
    background: rgba(124, 58, 237, 0.08);
    border: 1px solid rgba(124, 58, 237, 0.2);
    color: #7c3aed;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 20px;
}

.diagnostic-tag {
    font-size: 0.62rem;
    color: #10b981;
    font-weight: 500;
    letter-spacing: 0.03em;
}

.ssh-slate-item {
    background: var(--surface-light);
    border: 1px solid var(--card-border);
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 10px;
}

.ssh-item-info .name {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-main);
}

.ssh-item-info .ip {
    font-size: 0.75rem;
    color: var(--text-secondary);
    font-family: 'Outfit', sans-serif;
}

.status-dot-min.active {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
    margin-left: auto;
}

.ssh-footer-hint {
    font-size: 0.65rem;
    color: var(--text-muted);
    margin-top: 1.5rem;
    text-align: center;
}

.lbl-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pulse-icon-v2-warn {
    color: #f59e0b;
    animation: pulseWarn 2s infinite;
}

@keyframes pulseWarn {
    0% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.6;
        transform: scale(1.1);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.status-tag-v2.warning {
    color: #f59e0b;
    background: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.2);
    padding: 2px 8px;
    border-radius: 4px;
}

.val.error {
    color: #ef4444 !important;
}

/* Smart Console Prompt */
.log-prompt {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px dashed rgba(255, 255, 255, 0.15);
    color: #34d399;
    font-weight: 600;
    font-size: 0.82rem;
    text-shadow: 0 0 8px rgba(52, 211, 153, 0.3);
}

.log-prompt.offline {
    color: #f87171;
    text-shadow: 0 0 8px rgba(248, 113, 113, 0.3);
}

.log-prompt .cursor {
    width: 8px;
    height: 14px;
    background: currentColor;
    box-shadow: 0 0 8px currentColor;
    animation: blink 1s infinite;
}

@keyframes blink {
    50% {
        opacity: 0;
    }
}

/* Help Modal */
.help-overlay-ref {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.65);
    backdrop-filter: blur(12px) saturate(140%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    animation: overlayFadeIn 0.3s ease-out forwards;
}

html[data-theme="light"] .help-overlay-ref {
    background: rgba(15, 23, 42, 0.3);
    backdrop-filter: blur(8px);
}

.help-modal-ref {
    --modal-bg: #2a3447;
    background: linear-gradient(135deg, var(--modal-bg) 0%, #172033 100%);
    border: var(--glass-border);
    width: 650px;
    max-width: 90vw;
    border-radius: 24px;
    padding: 2.5rem;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), var(--glass-inner-glow);
    animation: modalSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    display: flex;
    flex-direction: column;
}

html[data-theme="light"] .help-modal-ref {
    --modal-bg: #f8fafc;
    background: linear-gradient(135deg, var(--modal-bg) 0%, #e2e8f0 100%);
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12), var(--glass-inner-glow);
}

.help-modal-header-ref {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--card-border);
    padding-bottom: 1.25rem;
    margin-bottom: 1rem;
}

.help-modal-close-btn {
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid transparent;
}

.help-modal-close-btn:hover {
    background: var(--surface-light);
    color: var(--text-main);
    border-color: var(--card-border);
    transform: rotate(90deg);
}

.help-modal-body-ref::-webkit-scrollbar {
    width: 6px;
}

.help-modal-body-ref::-webkit-scrollbar-track {
    background: transparent;
}

.help-modal-body-ref::-webkit-scrollbar-thumb {
    background: var(--card-border);
    border-radius: 10px;
}

.help-modal-body-ref::-webkit-scrollbar-thumb:hover {
    background: var(--text-muted);
}

/* Prerequisites Card styling */
.guide-prerequisites-card {
    margin-bottom: 2rem;
    padding: 1.25rem 1.5rem;
    background: rgba(245, 158, 11, 0.03);
    border-radius: 16px;
    border: 1px solid rgba(245, 158, 11, 0.15);
    position: relative;
    overflow: hidden;
}

html[data-theme="light"] .guide-prerequisites-card {
    background: rgba(245, 158, 11, 0.06);
    border-color: rgba(245, 158, 11, 0.3);
}

.guide-prerequisites-card::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #f59e0b;
}

.guide-prerequisites-card h4 {
    margin: 0 0 0.75rem 0;
    color: #f59e0b;
    font-size: 0.95rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
}

.guide-prerequisites-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.guide-prerequisites-list li {
    position: relative;
    padding-left: 1.25rem;
    font-size: 0.85rem;
    line-height: 1.5;
    color: var(--text-muted);
}

.guide-prerequisites-list li::before {
    content: '→';
    position: absolute;
    left: 0;
    color: #f59e0b;
    font-weight: bold;
}

/* Timeline / Stepper Styling */
.timeline-stepper {
    position: relative;
    padding-left: 2rem;
    margin-top: 1.5rem;
    margin-bottom: 2.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
}

.timeline-stepper::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 8px;
    bottom: 8px;
    width: 2px;
    background: linear-gradient(to bottom, var(--primary) 0%, var(--secondary) 50%, var(--card-border) 100%);
    border-radius: 1px;
}

.timeline-item {
    position: relative;
    display: flex;
    flex-direction: column;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    border-radius: 16px;
    padding: 1.25rem 1.5rem;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.timeline-item:hover {
    transform: translateX(6px);
    background: var(--card-hover-bg);
    border-color: rgba(99, 102, 241, 0.35);
    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.3);
}

.timeline-item::before {
    content: '';
    position: absolute;
    left: -31px;
    top: 20px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--modal-bg, var(--background));
    border: 3px solid var(--primary);
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
    transition: all 0.3s ease;
    z-index: 2;
}

html[data-theme="light"] .timeline-item {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

html[data-theme="light"] .timeline-item:hover {
    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12);
}

.timeline-item:hover::before {
    background: var(--primary);
    box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.3);
}

.timeline-step-pill {
    align-self: flex-start;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 8px;
    background: rgba(99, 102, 241, 0.08);
    border: 1px solid rgba(99, 102, 241, 0.2);
    color: var(--primary);
}

.timeline-item:nth-child(even) .timeline-step-pill {
    background: rgba(139, 92, 246, 0.08);
    border: 1px solid rgba(139, 92, 246, 0.2);
    color: var(--secondary);
}

.timeline-item:nth-child(even)::before {
    border-color: var(--secondary);
    box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.15);
}

.timeline-item:nth-child(even):hover::before {
    background: var(--secondary);
    box-shadow: 0 0 0 6px rgba(139, 92, 246, 0.3);
}

.timeline-step-title {
    margin: 0 0 6px 0;
    font-size: 0.95rem;
    font-weight: 750;
    color: var(--text-main);
    display: flex;
    align-items: center;
    gap: 8px;
}

.timeline-step-title svg {
    opacity: 0.85;
}

.timeline-step-desc {
    margin: 0;
    font-size: 0.82rem;
    color: var(--text-muted);
    line-height: 1.5;
}

.timeline-step-desc strong {
    color: var(--text-main);
}

.timeline-step-desc code {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid var(--card-border);
    padding: 2px 6px;
    border-radius: 6px;
    font-family: 'Fira Code', monospace;
    font-size: 0.8em;
    color: var(--primary);
}

@keyframes modalSlideUp {
    from {
        opacity: 0;
        transform: translateY(24px) scale(0.97);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes overlayFadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.cancel {
    background: var(--surface-light);
    color: var(--text-secondary);
    border: var(--glass-border);
}

.danger {
    background: #ef4444;
    color: white;
    border: none;
}

/* Beautified Destruction Modal */
.destroy-warn-box {
    text-align: center;
    border-top: 6px solid #ef4444;
}

.destroy-icon-wrapper {
    margin-bottom: 1.5rem;
    animation: pulseDanger 2s infinite;
}

@keyframes pulseDanger {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.destroy-title {
    color: #e11d48;
    font-size: 1.6rem;
    font-weight: 500;
    margin-bottom: 1rem;
}

.destroy-desc {
    font-size: 0.95rem;
    line-height: 1.6;
    color: var(--text-secondary);
    margin-bottom: 2rem;
}

.confirm-input-group {
    margin-bottom: 2rem;
    text-align: left;
    background: rgba(239, 68, 68, 0.03);
    padding: 1.25rem;
    border-radius: 12px;
    border: 1px solid rgba(239, 68, 68, 0.1);
}

.confirm-input-group label {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    color: var(--text-main);
}

.confirm-input {
    width: 100%;
    background: var(--bg-input);
    border: 1.5px solid var(--border-color);
    padding: 0.9rem 1rem;
    border-radius: 12px;
    color: #e11d48;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-align: center;
    font-size: 1rem;
}

.confirm-input:focus {
    outline: 2px solid #ef4444;
    border-color: transparent;
}

.modal-actions-ref {
    display: flex;
    gap: 1rem;
    justify-content: stretch;
}

.modal-actions-ref button {
    flex: 1 1;
    padding: 0.9rem;
    border-radius: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.cancel-v2 {
    background: var(--surface-light);
    color: var(--text-secondary);
    border: 1px solid var(--border-color);
}

.cancel-v2:hover {
    background: var(--surface);
    color: var(--text-main);
}

.danger-v2 {
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.danger-v2.disabled {
    background: var(--surface-light);
    color: var(--text-muted);
    cursor: not-allowed;
    opacity: 0.6;
}

.danger-v2.active {
    background: #ef4444;
    color: white;
    box-shadow: 0 10px 20px rgba(239, 68, 68, 0.3);
}

.danger-v2.active:hover {
    background: #dc2626;
    transform: translateY(-2px);
    box-shadow: 0 15px 30px rgba(239, 68, 68, 0.4);
}

.danger-v2.active:active {
    transform: translateY(0);
}

/* Tooltip & Popover Styles for Field Help Buttons */
.flex-label {
    display: flex;
    align-items: center;
    gap: 6px;
    position: relative;
    width: 100%;
}

.field-help-btn {
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 2px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.field-help-btn:hover {
    color: var(--primary);
    background: var(--surface-light);
}

.field-tooltip-popover {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 100;
    width: 280px;
    background: #1e293b;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 12px 14px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5), 0 8px 10px -6px rgba(0, 0, 0, 0.5);
    animation: tooltipFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.field-tooltip-popover.right-aligned {
    left: auto;
    right: 0;
}

html[data-theme="light"] .field-tooltip-popover {
    background: #ffffff;
    border-color: rgba(0, 0, 0, 0.08);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08);
}

@keyframes tooltipFadeIn {
    from {
        opacity: 0;
        transform: translateY(4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.tooltip-arrow {
    position: absolute;
    top: -6px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #1e293b;
}

html[data-theme="light"] .tooltip-arrow {
    border-bottom-color: #ffffff;
}

.tooltip-title {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--text-main);
    margin: 0 0 6px 0;
}

.tooltip-steps {
    margin: 0;
    padding-left: 1rem;
    font-size: 0.72rem;
    line-height: 1.4;
    color: var(--text-muted);
}

.tooltip-steps li {
    margin-bottom: 5px;
}

/* Success Modal */
.success-modal-box {
    text-align: center;
    border-top: 6px solid #10b981;
}

.success-icon-wrapper {
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.success-heartbeat-ring {
    width: 80px;
    height: 80px;
    background: rgba(16, 185, 129, 0.05);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.success-heartbeat-ring::after {
    content: '';
    position: absolute;
    inset: -3px;
    border: 2px solid rgba(16, 185, 129, 0.3);
    border-radius: 50%;
    animation: ripple 2s infinite;
}

.success-title {
    color: #10b981;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.success-desc {
    font-size: 0.95rem;
    line-height: 1.6;
    color: var(--text-secondary);
    margin-bottom: 1.5rem;
}

.modal-checklist-card {
    background: rgba(16, 185, 129, 0.03);
    border: 1px solid rgba(16, 185, 129, 0.15);
    border-radius: 16px;
    padding: 1.25rem;
    text-align: left;
    margin-bottom: 1rem;
}

html[data-theme="light"] .modal-checklist-card {
    background: rgba(16, 185, 129, 0.06);
    border-color: rgba(16, 185, 129, 0.3);
}

.success-btn-v2:hover {
    background: #059669 !important;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(16, 185, 129, 0.3);
}

.success-btn-v2:active {
    transform: translateY(0);
}

/* ─── Modern UX Enhancements ─── */

.animate-in {
    opacity: 0;
    transform: translateY(12px);
    animation: fadeInUpPC 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes fadeInUpPC {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.pulse-icon-v2 {
    color: #10b981;
    animation: pulseSuccess 2s infinite ease-in-out;
}

@keyframes pulseSuccess {
    0% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.7;
        transform: scale(1.08);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

/* Offline Glow & Pill Styling */
.heartbeat-ring.offline {
    color: #ef4444 !important;
    border-color: rgba(239, 68, 68, 0.3) !important;
    background-color: rgba(239, 68, 68, 0.05) !important;
    box-shadow: 0 0 15px rgba(239, 68, 68, 0.15);
    animation: pulseError 2.5s infinite;
}

@keyframes pulseError {
    0% {
        box-shadow: 0 0 15px rgba(239, 68, 68, 0.1);
        border-color: rgba(239, 68, 68, 0.25);
    }

    50% {
        box-shadow: 0 0 25px rgba(239, 68, 68, 0.25);
        border-color: rgba(239, 68, 68, 0.45);
    }

    100% {
        box-shadow: 0 0 15px rgba(239, 68, 68, 0.1);
        border-color: rgba(239, 68, 68, 0.25);
    }
}

.status-tag-v2.offline {
    color: #ef4444 !important;
    background: rgba(239, 68, 68, 0.05) !important;
    border: 1px solid rgba(239, 68, 68, 0.2) !important;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    box-shadow: 0 2px 10px rgba(239, 68, 68, 0.05);
}

.val.error {
    color: #ef4444 !important;
    text-shadow: 0 0 8px rgba(239, 68, 68, 0.15);
}

/* Responsive Sticky Sidebar Stack */
@media (max-width: 1024px) {
    .main-config-layout {
        grid-template-columns: 1fr !important;
        gap: 2rem !important;
    }

    .status-side-panel {
        position: static !important;
        margin-top: 1rem !important;
    }
}

/* Light Mode Terminal Overrides */
html[data-theme='light'] .terminal-body {
    background: rgba(255, 255, 255, 0.45) !important;
    color: #1e293b !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05), 0 4px 20px rgba(0, 0, 0, 0.05);
}

html[data-theme='light'] .log-content {
    color: #1e293b !important;
}

html[data-theme='light'] .log-placeholder {
    color: #64748b !important;
}

html[data-theme='light'] .log-line.add .log-content {
    color: #15803d !important;
    /* Dark green */
    text-shadow: none !important;
}

html[data-theme='light'] .log-line.destroy .log-content {
    color: #b91c1c !important;
    /* Dark red */
    text-shadow: none !important;
}

html[data-theme='light'] .log-line.change .log-content {
    color: #b45309 !important;
    /* Dark orange */
    text-shadow: none !important;
}

html[data-theme='light'] .log-line.plan-summary .log-content {
    color: #0369a1 !important;
    /* Dark blue/cyan */
    font-weight: 600;
    text-shadow: none !important;
}

html[data-theme='light'] .log-line.success-exit {
    background: rgba(22, 163, 74, 0.1) !important;
    border-left: 4px solid #16a34a;
}

html[data-theme='light'] .log-line.success-exit .log-content {
    color: #15803d !important;
    text-shadow: none !important;
}

html[data-theme='light'] .log-prompt {
    border-top: 1px dashed rgba(0, 0, 0, 0.15) !important;
    color: #16a34a !important;
    text-shadow: none !important;
}

html[data-theme='light'] .log-prompt.offline {
    color: #dc2626 !important;
    text-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/dms/PrivateConnectivity.css"],"names":[],"mappings":"AAAA;IACI,sDAAsD;IACtD,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,mFAAmF;;;;AAInF;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB;IACnB,sCAAsC;IACtC,wDAAwD;IACxD,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB;IACnB,sCAAsC;IACtC,wDAAwD;IACxD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,0BAA0B;IAC1B,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,kCAAkC;IAClC,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,wDAAwD;IACxD,mDAAmD;AACvD;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,+CAA+C;IAC/C,iEAAiE;AACrE;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,gDAAgD;IAChD,kEAAkE;AACtE;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,+CAA+C;IAC/C,iEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;;IAEI,iCAAiC;IACjC,2BAA2B;IAC3B,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,kCAAkC;IAClC,yCAAyC;AAC7C;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,sCAAsC;IACtC,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,aAAa;AACb;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,sCAAsC;IACtC,mBAAmB;IACnB,wDAAwD;IACxD,eAAe;IACf,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mEAAmE;IACnE,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kDAAkD;IAClD,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;IACvB,qCAAqC;IACrC,2BAA2B;IAC3B,uEAAuE;AAC3E;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kDAAkD;IAClD,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,wCAAwC;IACxC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yHAAyH;IACzH,qDAAqD;IACrD,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;IACzC,6CAA6C;IAC7C,4CAA4C;AAChD;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;IACxC,6CAA6C;IAC7C,2CAA2C;AAC/C;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;IAC9C,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;IAClC,mBAAmB;IACnB,uDAAuD;IACvD,gBAAgB;IAChB,iEAAiE;IACjE,kHAAkH;AACtH;;AAEA;IACI,uCAAuC;IACvC,gDAAgD;IAChD,wGAAwG;AAC5G;;AAEA;IACI,sDAAsD;IACtD,gEAAgE;AACpE;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,+CAA+C;IAC/C,sGAAsG;AAC1G;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,qCAAqC;IACrC,kCAAkC;IAClC,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,wDAAwD;IACxD,mDAAmD;AACvD;;AAEA;IACI,uCAAuC;IACvC,qEAAqE;IACrE,gDAAgD;AACpD;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,gDAAgD;IAChD,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,eAAe;AACf;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qEAAqE;IACrE,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,mEAAmE;IACnE,mEAAmE;IACnE,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,qEAAqE;IACrE,oEAAoE;AACxE;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2CAA2C;IAC3C,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,UAAU;IACV,wGAAwG;IACxG,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,oCAAoC;IACpC,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,iFAAiF;AACrF;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,gCAAgC;IAChC,8CAA8C;IAC9C,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,4BAA4B;IAC5B,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,uCAAuC;IACvC,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,SAAO;IACP,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,mFAAmF;IACnF,oEAAoE;AACxE;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,oFAAoF;AACxF;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,mCAAmC;;AAEnC;IACI,UAAU;IACV,2BAA2B;IAC3B,iEAAiE;AACrE;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,gCAAgC;AAChC;IACI,yBAAyB;IACzB,+CAA+C;IAC/C,oDAAoD;IACpD,4CAA4C;IAC5C,mCAAmC;AACvC;;AAEA;IACI;QACI,2CAA2C;QAC3C,qCAAqC;IACzC;;IAEA;QACI,4CAA4C;QAC5C,qCAAqC;IACzC;;IAEA;QACI,2CAA2C;QAC3C,qCAAqC;IACzC;AACJ;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,mDAAmD;IACnD,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA,oCAAoC;AACpC;IACI;QACI,qCAAqC;QACrC,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;IAC/B;AACJ;;AAEA,kCAAkC;AAClC;IACI,gDAAgD;IAChD,yBAAyB;IACzB,+CAA+C;IAC/C,+EAA+E;AACnF;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC","sourcesContent":[".connectivity-container {\n    font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;\n    padding: 0 0 5rem;\n    max-width: 1800px;\n    margin: 0;\n    animation: fadeIn 0.4s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */\n\n\n\n.header-actions {\n    display: flex;\n    gap: 15px;\n}\n\n.help-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    background: var(--surface-light);\n    border: var(--glass-border);\n    border-radius: 12px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.status-badge-active {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    background: rgba(16, 185, 129, 0.08);\n    border: 1px solid rgba(16, 185, 129, 0.2);\n    color: #10b981;\n    border-radius: 20px;\n    font-weight: 600;\n    font-size: 0.8rem;\n}\n\n/* ── LAYOUT GRID (RESTORED) ── */\n.connectivity-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n}\n\n.main-config-layout {\n    display: grid;\n    grid-template-columns: 1fr 340px;\n    gap: 2.5rem;\n    align-items: start;\n}\n\n.config-card {\n    background: transparent;\n    backdrop-filter: none;\n    border: none;\n    box-shadow: none;\n    overflow: visible;\n    transition: all 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n\n.config-card:hover {\n    border-color: transparent;\n}\n\n.card-header {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border-radius: 24px;\n    border: var(--glass-border) !important;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    padding: 1.5rem 2.5rem;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.card-header h3 {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: var(--text-secondary);\n    margin: 0;\n}\n\n.icon-wrap.vpn {\n    width: 38px;\n    height: 38px;\n    background: var(--gradient-main);\n    color: white;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.multi-cloud-selector {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border-radius: 24px;\n    border: var(--glass-border) !important;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1.75rem 2.5rem;\n    gap: 2rem;\n}\n\n.selector-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.selector-group label {\n    font-size: 0.72rem;\n    font-weight: 500;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.cloud-chips {\n    display: flex;\n    gap: 10px;\n}\n\n.cloud-chip {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 0.7rem;\n    background: var(--bg-card);\n    border: 1.5px solid var(--border-color);\n    border-radius: 14px;\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.cloud-chip.active {\n    background: var(--surface);\n    color: var(--text-main);\n    border-width: 2px;\n}\n\n.cloud-chip.active:has(img[alt=\"AWS\"]) {\n    border-color: #FF9900;\n}\n\n.cloud-chip.active:has(img[alt=\"GCP\"]) {\n    border-color: #4285F4;\n}\n\n.cloud-chip.active:has(img[alt=\"Azure\"]) {\n    border-color: #0089D6;\n}\n\n.swap-btn {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    background: var(--surface-light);\n    border: var(--glass-border);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-muted);\n    margin-top: 1.5rem;\n    cursor: pointer;\n}\n\n/* Provider Slates */\n.provider-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    padding: 0;\n}\n\n.provider-section {\n    padding: 2.5rem;\n    border-radius: 24px;\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border) !important;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.provider-section.source,\n.provider-section.target {\n    border-top: none !important;\n}\n\n.provider-section.aws {\n    border: 1px solid rgba(255, 153, 0, 0.3) !important;\n}\n\nhtml[data-theme='dark'] .provider-section.aws {\n    box-shadow: 0 0 35px rgba(255, 153, 0, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.provider-section.aws:hover {\n    border-color: rgba(255, 153, 0, 0.6) !important;\n    box-shadow: 0 0 45px rgba(255, 153, 0, 0.18), var(--glass-shadow);\n}\n\n.provider-section.gcp {\n    border: 1px solid rgba(66, 133, 244, 0.3) !important;\n}\n\nhtml[data-theme='dark'] .provider-section.gcp {\n    box-shadow: 0 0 35px rgba(66, 133, 244, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.provider-section.gcp:hover {\n    border-color: rgba(66, 133, 244, 0.6) !important;\n    box-shadow: 0 0 45px rgba(66, 133, 244, 0.18), var(--glass-shadow);\n}\n\n.provider-section.azure {\n    border: 1px solid rgba(0, 137, 214, 0.3) !important;\n}\n\nhtml[data-theme='dark'] .provider-section.azure {\n    box-shadow: 0 0 35px rgba(0, 137, 214, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.provider-section.azure:hover {\n    border-color: rgba(0, 137, 214, 0.6) !important;\n    box-shadow: 0 0 45px rgba(0, 137, 214, 0.18), var(--glass-shadow);\n}\n\n.provider-label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 0.72rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.provider-section.source .provider-label {\n    color: #FF9900;\n}\n\n.provider-section.target .provider-label {\n    color: #4285F4;\n}\n\n.discovery-pill.success {\n    background: rgba(16, 185, 129, 0.08);\n    color: #10b981;\n    padding: 4px 12px;\n    border-radius: 10px;\n    font-size: 0.7rem;\n    font-weight: 600;\n}\n\n/* Forms */\n.form-group label {\n    font-size: 0.78rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    margin-bottom: 8px;\n}\n\n.form-input,\n.form-select {\n    font-family: 'Outfit', sans-serif;\n    background: var(--bg-input);\n    border: 1.5px solid var(--border-color);\n    border-radius: 12px;\n    padding: 12px 16px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--text-main);\n    width: 100%;\n    transition: all 0.2s;\n}\n\n.form-input:focus,\n.form-select:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 4px var(--primary-glow);\n}\n\n/* Shared Params */\n.shared-config-area {\n    padding: 2.5rem;\n    border: var(--glass-border) !important;\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border-radius: 24px;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.input-with-button {\n    display: flex;\n    align-items: stretch;\n    gap: 15px;\n}\n\n.save-config-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    padding: 0 28px;\n    font-weight: 600;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    white-space: nowrap;\n    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.save-config-btn:hover {\n    background: #2563eb;\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.35);\n}\n\n.save-config-btn:active {\n    transform: translateY(0);\n}\n\n.input-hint {\n    margin-top: 10px;\n    font-size: 0.68rem;\n    color: var(--text-muted);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Terminal */\n.terraform-terminal-wrap {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border) !important;\n    border-radius: 24px;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    padding: 2.5rem;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n}\n\nhtml[data-theme=\"light\"] .terraform-terminal-wrap {\n    background: var(--card-bg) !important;\n}\n\n.terminal-header {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 1.5rem;\n}\n\n.terminal-expand-btn {\n    margin-left: auto;\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 6px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    border: 1px solid transparent;\n}\n\n.terminal-expand-btn:hover {\n    background: var(--surface-light);\n    color: var(--text-main);\n    border-color: var(--card-border);\n}\n\n.terminal-modal-ref {\n    background: var(--card-bg) !important;\n    backdrop-filter: var(--glass-blur) !important;\n    border: var(--glass-border) !important;\n    width: 90vw;\n    height: 90vh;\n    border-radius: 24px;\n    padding: 3rem;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow) !important;\n    display: flex;\n    flex-direction: column;\n}\n\n.terminal-modal-header {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 1.5rem;\n}\n\n.terminal-close-btn {\n    margin-left: auto;\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 6px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    border: 1px solid transparent;\n}\n\n.terminal-close-btn:hover {\n    background: rgba(239, 68, 68, 0.1);\n    color: #ef4444;\n    border-color: rgba(239, 68, 68, 0.2);\n}\n\n.terminal-modal-ref .terminal-body {\n    flex: 1;\n    height: auto;\n}\n\n.terminal-dots {\n    display: flex;\n    gap: 8px;\n}\n\n.dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n}\n\n.dot.red {\n    background: #ff5f56;\n    box-shadow: 0 0 6px rgba(255, 95, 86, 0.5);\n}\n\n.dot.yellow {\n    background: #ffbd2e;\n    box-shadow: 0 0 6px rgba(255, 189, 46, 0.5);\n}\n\n.dot.green {\n    background: #27c93f;\n    box-shadow: 0 0 6px rgba(39, 201, 63, 0.5);\n}\n\n.terminal-title {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n}\n\n.terminal-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 1.5rem;\n}\n\n.step-btn {\n    background: var(--surface-light);\n    border: var(--glass-border);\n    backdrop-filter: var(--glass-blur);\n    padding: 10px 20px;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: var(--glass-inner-glow);\n}\n\n.step-btn:hover:not(:disabled) {\n    background: var(--gradient-hover);\n    color: var(--text-main);\n    border-color: rgba(99, 102, 241, 0.3);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1), var(--glass-inner-glow);\n}\n\n.step-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.apply-btn {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    border: none;\n    padding: 10px 24px;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.apply-btn:hover:not(:disabled) {\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\n    transform: translateY(-1.5px);\n    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.35);\n}\n\n.apply-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.destroy-btn-ref {\n    margin-left: auto;\n    background: rgba(239, 68, 68, 0.05);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    color: #ef4444;\n    padding: 10px 20px;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 0.85rem;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.destroy-btn-ref:hover:not(:disabled) {\n    background: rgba(239, 68, 68, 0.1);\n    border-color: rgba(239, 68, 68, 0.45);\n    color: #f87171;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.1);\n}\n\n.destroy-btn-ref:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.terminal-body {\n    background: rgba(10, 12, 22, 0.85) !important;\n    backdrop-filter: blur(16px);\n    border-radius: 16px;\n    padding: 24px;\n    height: 320px;\n    overflow-y: auto;\n    font-family: 'Fira Code', 'JetBrains Mono', 'SF Mono', Consolas, monospace;\n    font-size: 0.85rem;\n    line-height: 1.7;\n    color: #f8fafc;\n    box-shadow: inset 0 2px 20px rgba(0, 0, 0, 0.85), inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 4px 20px rgba(0, 0, 0, 0.15);\n    border: 1px solid rgba(99, 102, 241, 0.25) !important;\n    transition: all 0.3s ease;\n}\n\n.terminal-body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.terminal-body::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 4px;\n}\n\n.terminal-body::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n}\n\n.terminal-body::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.log-placeholder {\n    color: #94a3b8;\n    opacity: 0.7;\n}\n\n.log-line {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 4px;\n    word-break: break-all;\n    transition: background 0.2s;\n    padding: 2px 4px;\n    border-radius: 4px;\n}\n\n.log-line:hover {\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.log-prefix {\n    font-weight: 700;\n    font-size: 0.75rem;\n    padding: 2px 6px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    height: fit-content;\n    margin-top: 2px;\n}\n\n.log-prefix.sys {\n    background: rgba(99, 102, 241, 0.12);\n    color: #818cf8;\n    border: 1px solid rgba(99, 102, 241, 0.3);\n    text-shadow: 0 0 8px rgba(129, 140, 248, 0.4);\n    box-shadow: 0 0 8px rgba(99, 102, 241, 0.05);\n}\n\n.log-prefix.err {\n    background: rgba(239, 68, 68, 0.12);\n    color: #f87171;\n    border: 1px solid rgba(239, 68, 68, 0.3);\n    text-shadow: 0 0 8px rgba(248, 113, 113, 0.4);\n    box-shadow: 0 0 8px rgba(239, 68, 68, 0.05);\n}\n\n.log-content {\n    flex: 1;\n    white-space: pre-wrap;\n    color: #f8fafc;\n}\n\n.log-line.add .log-content {\n    color: #4ade80;\n    text-shadow: 0 0 8px rgba(74, 222, 128, 0.25);\n}\n\n.log-line.destroy .log-content {\n    color: #f87171;\n    text-shadow: 0 0 8px rgba(248, 113, 113, 0.25);\n}\n\n.log-line.change .log-content {\n    color: #fbbf24;\n    text-shadow: 0 0 8px rgba(251, 191, 36, 0.25);\n}\n\n.log-line.plan-summary .log-content {\n    color: #22d3ee;\n    font-weight: 600;\n    text-shadow: 0 0 10px rgba(34, 211, 238, 0.3);\n}\n\n.log-line.success-exit {\n    background: rgba(16, 185, 129, 0.1) !important;\n    border-left: 4px solid #10b981;\n    box-shadow: inset 0 0 15px rgba(16, 185, 129, 0.1);\n}\n\n.log-line.success-exit .log-content {\n    color: #34d399;\n    font-weight: 700;\n    text-shadow: 0 0 10px rgba(52, 211, 153, 0.4);\n}\n\n/* Status Panel (Side) */\n.status-side-panel {\n    position: sticky;\n    top: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 2.25rem;\n    height: fit-content;\n    z-index: 10;\n}\n\n.status-card-ref {\n    background: var(--card-bg) !important;\n    backdrop-filter: var(--glass-blur);\n    border-radius: 24px;\n    border: 1.5px solid rgba(16, 185, 129, 0.35) !important;\n    padding: 1.75rem;\n    box-shadow: 0 0 15px rgba(16, 185, 129, 0.1), var(--glass-shadow);\n    transition: border-color 0.4s ease, box-shadow 0.4s ease, transform 0.35s cubic-bezier(0.16, 1, 0.3, 1) !important;\n}\n\n.status-card-ref:hover {\n    transform: translateY(-5px) scale(1.02);\n    border-color: rgba(16, 185, 129, 0.6) !important;\n    box-shadow: 0 0 25px rgba(16, 185, 129, 0.25), 0 20px 45px rgba(16, 185, 129, 0.15), var(--glass-shadow);\n}\n\n.status-card-ref.offline {\n    border: 1.5px solid rgba(239, 68, 68, 0.35) !important;\n    box-shadow: 0 0 15px rgba(239, 68, 68, 0.1), var(--glass-shadow);\n}\n\nhtml[data-theme='dark'] .status-card-ref {\n    box-shadow: 0 0 35px rgba(16, 185, 129, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\nhtml[data-theme='dark'] .status-card-ref.offline {\n    box-shadow: 0 0 35px rgba(239, 68, 68, 0.08), var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.status-card-ref.offline:hover {\n    border-color: rgba(239, 68, 68, 0.6) !important;\n    box-shadow: 0 0 25px rgba(239, 68, 68, 0.25), 0 20px 45px rgba(239, 68, 68, 0.15), var(--glass-shadow);\n}\n\n.status-header-min {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.status-visualization {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1rem 0;\n}\n\n.heartbeat-ring {\n    width: 64px;\n    height: 64px;\n    background: rgba(16, 185, 129, 0.05);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #10b981;\n    margin-bottom: 1rem;\n    position: relative;\n}\n\n.heartbeat-ring::after {\n    content: '';\n    position: absolute;\n    inset: -3px;\n    border: 2px solid rgba(16, 185, 129, 0.3);\n    border-radius: 50%;\n    animation: ripple 2s infinite;\n}\n\n@keyframes ripple {\n    0% {\n        transform: scale(1);\n        opacity: 0.5;\n    }\n\n    100% {\n        transform: scale(1.4);\n        opacity: 0;\n    }\n}\n\n.status-tag-v2 {\n    font-weight: 600;\n    font-size: 0.92rem;\n    color: var(--text-secondary);\n}\n\n.status-metas-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--card-border);\n}\n\n.meta-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: flex-start;\n}\n\n.meta-item .lbl {\n    font-size: 0.7rem;\n    color: var(--text-secondary);\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    line-height: 1.2;\n}\n\n.meta-item .val {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.meta-item .val.success {\n    color: #10b981;\n}\n\n/* SSH Ledger */\n.ssh-summary-card-ref {\n    background: var(--card-bg) !important;\n    backdrop-filter: var(--glass-blur);\n    border-radius: 24px;\n    border: var(--glass-border) !important;\n    padding: 1.75rem;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ssh-summary-card-ref:hover {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow: 0 20px 45px rgba(99, 102, 241, 0.15), var(--glass-shadow);\n    border-color: rgba(99, 102, 241, 0.4) !important;\n}\n\n.count-pill {\n    background: rgba(124, 58, 237, 0.08);\n    border: 1px solid rgba(124, 58, 237, 0.2);\n    color: #7c3aed;\n    font-size: 0.75rem;\n    font-weight: 600;\n    padding: 3px 10px;\n    border-radius: 20px;\n}\n\n.diagnostic-tag {\n    font-size: 0.62rem;\n    color: #10b981;\n    font-weight: 500;\n    letter-spacing: 0.03em;\n}\n\n.ssh-slate-item {\n    background: var(--surface-light);\n    border: 1px solid var(--card-border);\n    border-radius: 12px;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-top: 10px;\n}\n\n.ssh-item-info .name {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.ssh-item-info .ip {\n    font-size: 0.75rem;\n    color: var(--text-secondary);\n    font-family: 'Outfit', sans-serif;\n}\n\n.status-dot-min.active {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #10b981;\n    margin-left: auto;\n}\n\n.ssh-footer-hint {\n    font-size: 0.65rem;\n    color: var(--text-muted);\n    margin-top: 1.5rem;\n    text-align: center;\n}\n\n.lbl-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.pulse-icon-v2-warn {\n    color: #f59e0b;\n    animation: pulseWarn 2s infinite;\n}\n\n@keyframes pulseWarn {\n    0% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.6;\n        transform: scale(1.1);\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.status-tag-v2.warning {\n    color: #f59e0b;\n    background: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.2);\n    padding: 2px 8px;\n    border-radius: 4px;\n}\n\n.val.error {\n    color: #ef4444 !important;\n}\n\n/* Smart Console Prompt */\n.log-prompt {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px dashed rgba(255, 255, 255, 0.15);\n    color: #34d399;\n    font-weight: 600;\n    font-size: 0.82rem;\n    text-shadow: 0 0 8px rgba(52, 211, 153, 0.3);\n}\n\n.log-prompt.offline {\n    color: #f87171;\n    text-shadow: 0 0 8px rgba(248, 113, 113, 0.3);\n}\n\n.log-prompt .cursor {\n    width: 8px;\n    height: 14px;\n    background: currentColor;\n    box-shadow: 0 0 8px currentColor;\n    animation: blink 1s infinite;\n}\n\n@keyframes blink {\n    50% {\n        opacity: 0;\n    }\n}\n\n/* Help Modal */\n.help-overlay-ref {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.65);\n    backdrop-filter: blur(12px) saturate(140%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n    animation: overlayFadeIn 0.3s ease-out forwards;\n}\n\nhtml[data-theme=\"light\"] .help-overlay-ref {\n    background: rgba(15, 23, 42, 0.3);\n    backdrop-filter: blur(8px);\n}\n\n.help-modal-ref {\n    --modal-bg: #2a3447;\n    background: linear-gradient(135deg, var(--modal-bg) 0%, #172033 100%);\n    border: var(--glass-border);\n    width: 650px;\n    max-width: 90vw;\n    border-radius: 24px;\n    padding: 2.5rem;\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), var(--glass-inner-glow);\n    animation: modalSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    display: flex;\n    flex-direction: column;\n}\n\nhtml[data-theme=\"light\"] .help-modal-ref {\n    --modal-bg: #f8fafc;\n    background: linear-gradient(135deg, var(--modal-bg) 0%, #e2e8f0 100%);\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12), var(--glass-inner-glow);\n}\n\n.help-modal-header-ref {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid var(--card-border);\n    padding-bottom: 1.25rem;\n    margin-bottom: 1rem;\n}\n\n.help-modal-close-btn {\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    border: 1px solid transparent;\n}\n\n.help-modal-close-btn:hover {\n    background: var(--surface-light);\n    color: var(--text-main);\n    border-color: var(--card-border);\n    transform: rotate(90deg);\n}\n\n.help-modal-body-ref::-webkit-scrollbar {\n    width: 6px;\n}\n\n.help-modal-body-ref::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.help-modal-body-ref::-webkit-scrollbar-thumb {\n    background: var(--card-border);\n    border-radius: 10px;\n}\n\n.help-modal-body-ref::-webkit-scrollbar-thumb:hover {\n    background: var(--text-muted);\n}\n\n/* Prerequisites Card styling */\n.guide-prerequisites-card {\n    margin-bottom: 2rem;\n    padding: 1.25rem 1.5rem;\n    background: rgba(245, 158, 11, 0.03);\n    border-radius: 16px;\n    border: 1px solid rgba(245, 158, 11, 0.15);\n    position: relative;\n    overflow: hidden;\n}\n\nhtml[data-theme=\"light\"] .guide-prerequisites-card {\n    background: rgba(245, 158, 11, 0.06);\n    border-color: rgba(245, 158, 11, 0.3);\n}\n\n.guide-prerequisites-card::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    background: #f59e0b;\n}\n\n.guide-prerequisites-card h4 {\n    margin: 0 0 0.75rem 0;\n    color: #f59e0b;\n    font-size: 0.95rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.guide-prerequisites-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.guide-prerequisites-list li {\n    position: relative;\n    padding-left: 1.25rem;\n    font-size: 0.85rem;\n    line-height: 1.5;\n    color: var(--text-muted);\n}\n\n.guide-prerequisites-list li::before {\n    content: '→';\n    position: absolute;\n    left: 0;\n    color: #f59e0b;\n    font-weight: bold;\n}\n\n/* Timeline / Stepper Styling */\n.timeline-stepper {\n    position: relative;\n    padding-left: 2rem;\n    margin-top: 1.5rem;\n    margin-bottom: 2.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.75rem;\n}\n\n.timeline-stepper::before {\n    content: '';\n    position: absolute;\n    left: 9px;\n    top: 8px;\n    bottom: 8px;\n    width: 2px;\n    background: linear-gradient(to bottom, var(--primary) 0%, var(--secondary) 50%, var(--card-border) 100%);\n    border-radius: 1px;\n}\n\n.timeline-item {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    background: var(--card-bg);\n    border: 1px solid var(--card-border);\n    border-radius: 16px;\n    padding: 1.25rem 1.5rem;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.timeline-item:hover {\n    transform: translateX(6px);\n    background: var(--card-hover-bg);\n    border-color: rgba(99, 102, 241, 0.35);\n    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.3);\n}\n\n.timeline-item::before {\n    content: '';\n    position: absolute;\n    left: -31px;\n    top: 20px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: var(--modal-bg, var(--background));\n    border: 3px solid var(--primary);\n    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);\n    transition: all 0.3s ease;\n    z-index: 2;\n}\n\nhtml[data-theme=\"light\"] .timeline-item {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme=\"light\"] .timeline-item:hover {\n    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12);\n}\n\n.timeline-item:hover::before {\n    background: var(--primary);\n    box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.3);\n}\n\n.timeline-step-pill {\n    align-self: flex-start;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    padding: 4px 10px;\n    border-radius: 20px;\n    margin-bottom: 8px;\n    background: rgba(99, 102, 241, 0.08);\n    border: 1px solid rgba(99, 102, 241, 0.2);\n    color: var(--primary);\n}\n\n.timeline-item:nth-child(even) .timeline-step-pill {\n    background: rgba(139, 92, 246, 0.08);\n    border: 1px solid rgba(139, 92, 246, 0.2);\n    color: var(--secondary);\n}\n\n.timeline-item:nth-child(even)::before {\n    border-color: var(--secondary);\n    box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.15);\n}\n\n.timeline-item:nth-child(even):hover::before {\n    background: var(--secondary);\n    box-shadow: 0 0 0 6px rgba(139, 92, 246, 0.3);\n}\n\n.timeline-step-title {\n    margin: 0 0 6px 0;\n    font-size: 0.95rem;\n    font-weight: 750;\n    color: var(--text-main);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.timeline-step-title svg {\n    opacity: 0.85;\n}\n\n.timeline-step-desc {\n    margin: 0;\n    font-size: 0.82rem;\n    color: var(--text-muted);\n    line-height: 1.5;\n}\n\n.timeline-step-desc strong {\n    color: var(--text-main);\n}\n\n.timeline-step-desc code {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid var(--card-border);\n    padding: 2px 6px;\n    border-radius: 6px;\n    font-family: 'Fira Code', monospace;\n    font-size: 0.8em;\n    color: var(--primary);\n}\n\n@keyframes modalSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(24px) scale(0.97);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@keyframes overlayFadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.cancel {\n    background: var(--surface-light);\n    color: var(--text-secondary);\n    border: var(--glass-border);\n}\n\n.danger {\n    background: #ef4444;\n    color: white;\n    border: none;\n}\n\n/* Beautified Destruction Modal */\n.destroy-warn-box {\n    text-align: center;\n    border-top: 6px solid #ef4444;\n}\n\n.destroy-icon-wrapper {\n    margin-bottom: 1.5rem;\n    animation: pulseDanger 2s infinite;\n}\n\n@keyframes pulseDanger {\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n\n    50% {\n        transform: scale(1.1);\n        opacity: 0.8;\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.destroy-title {\n    color: #e11d48;\n    font-size: 1.6rem;\n    font-weight: 500;\n    margin-bottom: 1rem;\n}\n\n.destroy-desc {\n    font-size: 0.95rem;\n    line-height: 1.6;\n    color: var(--text-secondary);\n    margin-bottom: 2rem;\n}\n\n.confirm-input-group {\n    margin-bottom: 2rem;\n    text-align: left;\n    background: rgba(239, 68, 68, 0.03);\n    padding: 1.25rem;\n    border-radius: 12px;\n    border: 1px solid rgba(239, 68, 68, 0.1);\n}\n\n.confirm-input-group label {\n    display: block;\n    font-size: 0.8rem;\n    font-weight: 600;\n    margin-bottom: 0.75rem;\n    color: var(--text-main);\n}\n\n.confirm-input {\n    width: 100%;\n    background: var(--bg-input);\n    border: 1.5px solid var(--border-color);\n    padding: 0.9rem 1rem;\n    border-radius: 12px;\n    color: #e11d48;\n    font-weight: 500;\n    letter-spacing: 0.1em;\n    text-align: center;\n    font-size: 1rem;\n}\n\n.confirm-input:focus {\n    outline: 2px solid #ef4444;\n    border-color: transparent;\n}\n\n.modal-actions-ref {\n    display: flex;\n    gap: 1rem;\n    justify-content: stretch;\n}\n\n.modal-actions-ref button {\n    flex: 1;\n    padding: 0.9rem;\n    border-radius: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.cancel-v2 {\n    background: var(--surface-light);\n    color: var(--text-secondary);\n    border: 1px solid var(--border-color);\n}\n\n.cancel-v2:hover {\n    background: var(--surface);\n    color: var(--text-main);\n}\n\n.danger-v2 {\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.danger-v2.disabled {\n    background: var(--surface-light);\n    color: var(--text-muted);\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.danger-v2.active {\n    background: #ef4444;\n    color: white;\n    box-shadow: 0 10px 20px rgba(239, 68, 68, 0.3);\n}\n\n.danger-v2.active:hover {\n    background: #dc2626;\n    transform: translateY(-2px);\n    box-shadow: 0 15px 30px rgba(239, 68, 68, 0.4);\n}\n\n.danger-v2.active:active {\n    transform: translateY(0);\n}\n\n/* Tooltip & Popover Styles for Field Help Buttons */\n.flex-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    position: relative;\n    width: 100%;\n}\n\n.field-help-btn {\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 2px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.field-help-btn:hover {\n    color: var(--primary);\n    background: var(--surface-light);\n}\n\n.field-tooltip-popover {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    z-index: 100;\n    width: 280px;\n    background: #1e293b;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 12px 14px;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5), 0 8px 10px -6px rgba(0, 0, 0, 0.5);\n    animation: tooltipFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.field-tooltip-popover.right-aligned {\n    left: auto;\n    right: 0;\n}\n\nhtml[data-theme=\"light\"] .field-tooltip-popover {\n    background: #ffffff;\n    border-color: rgba(0, 0, 0, 0.08);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08);\n}\n\n@keyframes tooltipFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(4px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.tooltip-arrow {\n    position: absolute;\n    top: -6px;\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid #1e293b;\n}\n\nhtml[data-theme=\"light\"] .tooltip-arrow {\n    border-bottom-color: #ffffff;\n}\n\n.tooltip-title {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: var(--text-main);\n    margin: 0 0 6px 0;\n}\n\n.tooltip-steps {\n    margin: 0;\n    padding-left: 1rem;\n    font-size: 0.72rem;\n    line-height: 1.4;\n    color: var(--text-muted);\n}\n\n.tooltip-steps li {\n    margin-bottom: 5px;\n}\n\n/* Success Modal */\n.success-modal-box {\n    text-align: center;\n    border-top: 6px solid #10b981;\n}\n\n.success-icon-wrapper {\n    margin-bottom: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.success-heartbeat-ring {\n    width: 80px;\n    height: 80px;\n    background: rgba(16, 185, 129, 0.05);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.success-heartbeat-ring::after {\n    content: '';\n    position: absolute;\n    inset: -3px;\n    border: 2px solid rgba(16, 185, 129, 0.3);\n    border-radius: 50%;\n    animation: ripple 2s infinite;\n}\n\n.success-title {\n    color: #10b981;\n    font-size: 1.6rem;\n    font-weight: 700;\n    margin-bottom: 0.5rem;\n}\n\n.success-desc {\n    font-size: 0.95rem;\n    line-height: 1.6;\n    color: var(--text-secondary);\n    margin-bottom: 1.5rem;\n}\n\n.modal-checklist-card {\n    background: rgba(16, 185, 129, 0.03);\n    border: 1px solid rgba(16, 185, 129, 0.15);\n    border-radius: 16px;\n    padding: 1.25rem;\n    text-align: left;\n    margin-bottom: 1rem;\n}\n\nhtml[data-theme=\"light\"] .modal-checklist-card {\n    background: rgba(16, 185, 129, 0.06);\n    border-color: rgba(16, 185, 129, 0.3);\n}\n\n.success-btn-v2:hover {\n    background: #059669 !important;\n    transform: translateY(-2px);\n    box-shadow: 0 10px 20px rgba(16, 185, 129, 0.3);\n}\n\n.success-btn-v2:active {\n    transform: translateY(0);\n}\n\n/* ─── Modern UX Enhancements ─── */\n\n.animate-in {\n    opacity: 0;\n    transform: translateY(12px);\n    animation: fadeInUpPC 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes fadeInUpPC {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.pulse-icon-v2 {\n    color: #10b981;\n    animation: pulseSuccess 2s infinite ease-in-out;\n}\n\n@keyframes pulseSuccess {\n    0% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.7;\n        transform: scale(1.08);\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* Offline Glow & Pill Styling */\n.heartbeat-ring.offline {\n    color: #ef4444 !important;\n    border-color: rgba(239, 68, 68, 0.3) !important;\n    background-color: rgba(239, 68, 68, 0.05) !important;\n    box-shadow: 0 0 15px rgba(239, 68, 68, 0.15);\n    animation: pulseError 2.5s infinite;\n}\n\n@keyframes pulseError {\n    0% {\n        box-shadow: 0 0 15px rgba(239, 68, 68, 0.1);\n        border-color: rgba(239, 68, 68, 0.25);\n    }\n\n    50% {\n        box-shadow: 0 0 25px rgba(239, 68, 68, 0.25);\n        border-color: rgba(239, 68, 68, 0.45);\n    }\n\n    100% {\n        box-shadow: 0 0 15px rgba(239, 68, 68, 0.1);\n        border-color: rgba(239, 68, 68, 0.25);\n    }\n}\n\n.status-tag-v2.offline {\n    color: #ef4444 !important;\n    background: rgba(239, 68, 68, 0.05) !important;\n    border: 1px solid rgba(239, 68, 68, 0.2) !important;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    box-shadow: 0 2px 10px rgba(239, 68, 68, 0.05);\n}\n\n.val.error {\n    color: #ef4444 !important;\n    text-shadow: 0 0 8px rgba(239, 68, 68, 0.15);\n}\n\n/* Responsive Sticky Sidebar Stack */\n@media (max-width: 1024px) {\n    .main-config-layout {\n        grid-template-columns: 1fr !important;\n        gap: 2rem !important;\n    }\n\n    .status-side-panel {\n        position: static !important;\n        margin-top: 1rem !important;\n    }\n}\n\n/* Light Mode Terminal Overrides */\nhtml[data-theme='light'] .terminal-body {\n    background: rgba(255, 255, 255, 0.45) !important;\n    color: #1e293b !important;\n    border: 1px solid rgba(0, 0, 0, 0.1) !important;\n    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05), 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme='light'] .log-content {\n    color: #1e293b !important;\n}\n\nhtml[data-theme='light'] .log-placeholder {\n    color: #64748b !important;\n}\n\nhtml[data-theme='light'] .log-line.add .log-content {\n    color: #15803d !important;\n    /* Dark green */\n    text-shadow: none !important;\n}\n\nhtml[data-theme='light'] .log-line.destroy .log-content {\n    color: #b91c1c !important;\n    /* Dark red */\n    text-shadow: none !important;\n}\n\nhtml[data-theme='light'] .log-line.change .log-content {\n    color: #b45309 !important;\n    /* Dark orange */\n    text-shadow: none !important;\n}\n\nhtml[data-theme='light'] .log-line.plan-summary .log-content {\n    color: #0369a1 !important;\n    /* Dark blue/cyan */\n    font-weight: 600;\n    text-shadow: none !important;\n}\n\nhtml[data-theme='light'] .log-line.success-exit {\n    background: rgba(22, 163, 74, 0.1) !important;\n    border-left: 4px solid #16a34a;\n}\n\nhtml[data-theme='light'] .log-line.success-exit .log-content {\n    color: #15803d !important;\n    text-shadow: none !important;\n}\n\nhtml[data-theme='light'] .log-prompt {\n    border-top: 1px dashed rgba(0, 0, 0, 0.15) !important;\n    color: #16a34a !important;\n    text-shadow: none !important;\n}\n\nhtml[data-theme='light'] .log-prompt.offline {\n    color: #dc2626 !important;\n    text-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
